/**
 * Created by toomasp on 31.08.2015.
 */
"use strict";
export default [()=> {
    function replaceUrl(element, attributeName) {
        let url = $(element).attr(attributeName);
        if (url && url.indexOf('/') === 0)
            url = url.substring(1)

        if (url && url.indexOf('?') < 0 && !url.startsWith('javascript:') && url.indexOf('#') < 0)
            url += '?_=' + Date.now();

        $(element).attr(attributeName, url);
    }

    class ProxyLinkDirective {
        restrict = 'CA';

        link(scope, element) {
            if ($(element).prop('tagName') != 'A') return;

            replaceUrl(element, 'href');
        }
    }

    return new ProxyLinkDirective();
}];


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/proxy-link.directive.js